var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"footerImg"},[_c('img',{attrs:{"src":require('@/assets/img/pc/contactUs/7.png')}})]),_c('div',{staticClass:"footerNews"},[_vm._v(" "+_vm._s(_vm.footText())+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }